<template>
	<div>
		<!-- 路由导航 -->
		<div class="routerDh f-bct">
			<div class="l f-ct">
				<div class="t1">当前位置：</div>
				<!-- 课程管理
				<el-image :src="require('@/static/icon55.png')"></el-image>
				<div class="t1">开展信息化系统培训 咸宁市咸安区为液化气从业人员“充电”提能</div>
				<el-image :src="require('@/static/icon55.png')"></el-image> -->
				<div class="t2">报名人数</div>
			</div>
			<div class="r f-ct" @click="back()">
				<div class="t2">返回课程管理</div>
				<el-image :src="require('@/static/icon56.png')"></el-image>
			</div>
		</div>
		<div class="conBox animate__animated animate__fadeIn" data-wow-duration="0.8s">
		<!-- 筛选 -->
		<div class="shaixuan f-bct">
			<div class="l f-ct">
				<div class="itm">
					<span>报名时间</span>
					<el-date-picker
					v-model="value1"
					type="daterange"
					value-format="yyyy-MM-dd"
					range-separator="至"
					start-placeholder="开始日期"
					end-placeholder="结束日期">
					</el-date-picker>
				</div>
				<div class="itm">
					<span>用户名</span>
					<el-input type="text" v-model="keyword" placeholder="请输入搜索用户名"></el-input>
				</div>
			</div>
			<div class="seachBtn f-ct">
				<div @click="courseOrdercourseOrderList(1)">搜索</div>
				<div @click="keyword='',value1='',courseOrdercourseOrderList(1)">重置</div>
			</div>
		</div>
		<!-- 表格 -->
		<div class="zw" v-if="!msgList.length">
			<el-image :src="require('@/static/zw.png')"></el-image>
			<p>暂无相关数据...</p>
		</div>
		<div class="biaoge" v-if="msgList.length">
			<div class="table">
				<div class="th f-ct">
					<p class="t1">序号</p>
					<p class="t2">姓名</p>
					<p class="t3">性别</p>
					<p class="t4">身份证号码</p>
					<p class="t5">联系方式</p>
					<p class="t6">报名时间</p>
					<p class="t7">缴费状态</p>
				</div>
				<div class="td f-ct" v-for="(item,index) in msgList">
					<p class="t1">{{item.id}}</p>
					<p class="t2">{{item.memberName}}</p>
					<p class="t3" v-if="item.memberGender==0">未知</p>
					<p class="t3" v-if="item.memberGender==1">男</p>
					<p class="t3" v-if="item.memberGender==2">女</p>
					<p class="t4">{{item.memberIdentityCardCode}}</p>
					<p class="t5">{{item.memberMobile}}</p>
					<p class="t6">{{item.createTime}}</p>
					<p class="t7" v-if="item.payStatus==1">已缴费</p>
					<p class="t7 red"  v-if="item.payStatus==0">未缴费</p>
				</div>
			</div>
			<div class="fenye">
			<el-pagination
			background
			hide-on-single-page
			layout="prev, pager, next,jumper"
			@current-change="goPage"
			:page-size="pageSize"
			:total="total">
			</el-pagination>
			</div>
		</div>
		</div>
	</div>
</template>
<script>
import { courseOrdercourseOrderList } from "/src/api/api.js"
import {mapState,mapGetters,mapActions,mapMutations} from 'vuex'
export default {
	data(){
		return {
			id:0,
			value1:'',
			// 筛选
			keyword:'',
			// 分页
			pageNum:1,
			pageSize:10,
			total:0,
			// 列表
			msgList:[],
		}
	},
	mounted() {
		// 参数
		this.id = this.$route.query.id
		// 获取数据
		this.courseOrdercourseOrderList(1)
	},
	methods:{
		// 课程订单列表
		async courseOrdercourseOrderList(def){
			if(def){this.pageNum=1}
			var data = {}
			if(this.value1){
				data = {
					pageSize: this.pageSize,
					pageNum: this.pageNum,
					courseId:this.id,
					'params[beginTime]':this.value1[0],
					'params[endTime]':this.value1[1],
				}
			}else{
				data = {
					pageSize: this.pageSize,
					pageNum: this.pageNum,
					courseId:this.id,
				}
			}
			if(this.keyword){
				data.memberName = this.keyword
			}
			let res = await courseOrdercourseOrderList(data);
			if(res.code==200){
				if(this.pageNum==1){
					this.total = res.total
				}
				this.msgList = res.rows
			}else{this.Tips(res.msg,'error')}
		},
		// 跳转页
		goPage(e){
			// console.log(e)
			this.pageNum = e
			this.courseOrdercourseOrderList()
		},
	},
	computed:{
		...mapState('userMsg',['userInfo']),
	}
}
</script>
<style lang="scss">
body{
	// background: #f6f7fb;
}
</style>
<style lang="scss" scoped>
.routerDh{
	margin: 0 40px;
	margin-bottom: 24px;
	.l{
		.t1{
			font-size: 16px;
			color: #9A9DA7;
			cursor: pointer;
		}
		.el-image{
			width: 16px;
			height: 16px;
			margin: 0 2px;
		}
		.t2{
			font-size: 16px;
			color: #3B6492;
		}
	}
	.r{
		.t2{
			font-size: 16px;
			color: #3B6492;
		}
		.el-image{
			width: 18px;
			height: 18px;
			margin-left: 6px;
		}
	}
}
.conBox{
	margin: 0 40px;
	background: #fff;
	border-radius: 20px;
}
.shaixuan{
	padding: 0 24px;
	padding-top: 24px;
	margin-bottom: 24px;
	.l{
		.itm{
			display: flex;
			align-items: center;
			font-size: 16px;
			margin-right: 31px;
			span{
				display: block;
				width: 90px;
				padding-right: 16px;
			}
		}
	}
	.seachBtn{
		div{
			width: 85px;
			height: 40px;
			border: 1px solid #DDDDDD;
			font-size: 16px;
			color: #666666;
			text-align: center;
			line-height: 38px;
			cursor: pointer;
			border-radius: 6px;
			&:first-child{
				background: #3B6492;
				border: 1px solid #3B6492;
				color: #fff;
				margin-right: 12px;
			}
		}
	}
}
.biaoge{
	padding: 24px;
	padding-top: 0;
	// background: #fff;
	.table{
		border: 1px solid #EBEEF5;
		border-bottom: 0;
		.th{
			height: 40px;
			background: linear-gradient(180deg, #F8F9FE 0%, #EDEFF6 81.25%);
			p{
				line-height: 40px;
				text-align: center;
				font-size: 14px;
				color: #333333;
				font-weight: bold;
			}
			.t1{
				width: 100px;
			}
			.t2{
				width: 194px;
			}
			.t3{
				width: 166px;
			}
			.t4{
				width: 288px;
			}
			.t5{
				width: 288px;
			}
			.t6{
				width: 288px;
			}
			.t7{
				width: 194px;
			}
		}
		.td{
			border-bottom: 1px solid #EBEEF5;
			align-items: stretch;
			>p{
				line-height: 56px;
				text-align: center;
				font-size: 14px;
				color: #333333;
				border-right: 1px solid #EBEEF5;
				padding: 0 10px;
				&:last-child{
					border: none;
				}
			}
			.t1{
				width: 100px;
			}
			.t2{
				width: 194px;
			}
			.t3{
				width: 166px;
			}
			.t4{
				width: 288px;
			}
			.t5{
				width: 288px;
			}
			.t6{
				width: 288px;
			}
			.t7{
				width: 194px;
			}
			.blue{
				color: #3B6492;
			}
			.red{
				color: #FF5F5A;
			}
		}
	}
	.fenye{
		display: flex;
		align-items: center;
		justify-content: flex-end;
		margin-top: 26px;
		.i1{
			width: 24px;
			height: 24px;
			margin-right: 6px;
		}
		.fyitm{
			width: 32px;
			height: 32px;
			font-size: 12px;
			text-align: center;
			line-height: 32px;
			margin-right: 6px;
			border-radius: 4px;
		}
		.a{
			background: #3B6492;
			color: #fff;
		}
		.i2{
			width: 24px;
			height: 24px;
			margin-right: 19px;
		}
		.linkPage{
			p{
				font-size: 12px;
			}
			.ipt{
				margin: 0 6px;
				width: 42px;
				height: 32px;
				border-radius: 4px;
				background: #F4F4F4;
				.el-select{
					width: 100%;
				}
				::v-deep .el-input__inner{
					border: none;
					background: transparent;
				}
			}
		}
	}
}
</style>